import styled from 'styled-components';
export const LoadingMessage = styled.div `
  height: 100vh;
  line-height: 100vh;
  text-align: center;
  font-family: Amazon Ember, Helvetica, sans-serif;
  font-size: 17px;
`;
